import src from "IMAGE";
export default { src, width: 159, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AEdHVH5FR1N+QkRPc0hJVXtDRFByPT9KZj5CTXE3OkNeANHN0SnOy84kzcrNIc3KzSHPzNAmzs3RI8vM0CLHx8oZVAIec1ZKRn0AAAAASUVORK5CYII="};
